import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-aeb75e6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "select-screen" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "select-screen__text" }, "Выберите стиль эпохи", -1))
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]

import SelectScreenTextBg from "@/components/svg/SelectScreenTextBg.vue";
import HoverRing from "@/components/svg/HoverRing.vue";
import { inject, onMounted, ref } from "vue";
import { reachGoal } from "@/utils/reachGoal";

export default /*#__PURE__*/_defineComponent({
  __name: 'SelectScreen',
  emits: ["select"],
  setup(__props, { emit: __emit }) {

const data = inject("data");
const emit = __emit;

const onSelect = (data: 60 | 70 | 80) => {
  reachGoal(`${data}`);
  emit("select", data);
};
const container = ref<HTMLDivElement>();

const scrollToTop = () => {
  if (!container.value) {
    return;
  }

  const c = container.value?.scrollWidth / 100;

  if (container.value?.scrollLeft + c < container.value?.scrollWidth / 3) {
    container.value.scrollTo(container.value?.scrollLeft + c, 0);
    window.requestAnimationFrame(scrollToTop);
  }
};
scrollToTop();

const item = ref<HTMLDivElement>();

onMounted(() => {
  if (!item.value) {
    return;
  }
  console.log(container.value?.scrollLeft, container.value?.scrollWidth);
  setTimeout(() => {
    scrollToTop();
  }, 300);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(SelectScreenTextBg, { class: "select-screen__bg" }),
      _hoisted_2
    ]),
    _createElementVNode("div", {
      ref_key: "container",
      ref: container,
      class: "select-screen__buttons"
    }, [
      _createElementVNode("button", {
        class: "select-screen__button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (onSelect(60)))
      }, [
        _createElementVNode("img", {
          src: _unref(data)['60'],
          class: "icon"
        }, null, 8, _hoisted_3),
        _createElementVNode("img", {
          src: _unref(data)['hover-ring'],
          class: "select-screen__hover one"
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("button", {
        class: "select-screen__button",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (onSelect(70))),
        ref_key: "item",
        ref: item
      }, [
        _createElementVNode("img", {
          src: _unref(data)['70'],
          class: "icon"
        }, null, 8, _hoisted_5),
        _createElementVNode("img", {
          src: _unref(data)['hover-ring'],
          class: "select-screen__hover two"
        }, null, 8, _hoisted_6)
      ], 512),
      _createElementVNode("button", {
        class: "select-screen__button",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (onSelect(80)))
      }, [
        _createElementVNode("img", {
          src: _unref(data)['80'],
          class: "icon"
        }, null, 8, _hoisted_7),
        _createElementVNode("img", {
          src: _unref(data)['hover-ring'],
          class: "select-screen__hover three"
        }, null, 8, _hoisted_8)
      ])
    ], 512)
  ]))
}
}

})